import GlobalHelper from "../common/GlobalHelper"
import { Intl } from "../state/helpers/IntlProps"
import { defineMessages } from "react-intl"

const messages = defineMessages({
    "event_title": {
        id: "lsgolf_events",
        defaultMessage: "event",
    },
    "appointment_title": {
        id: "appointment",
        defaultMessage: "appointment",
    },
})

export function getEventName(intl: Intl): string {
    const hasLSGolfIntegration = GlobalHelper.hasGolfIntegration()
    if (hasLSGolfIntegration) {
        return intl.formatMessage(messages["event_title"])
    }
    return intl.formatMessage(messages["appointment_title"])
}


// WEBPACK FOOTER //
// ./src/name-helpers/eventNameHelper.tsx